import { Collection as API } from '@src/api/types';
import { baseURL } from '@src/configuration/constants';
import {
  generateJourney,
  generatePost,
  generatePrimeBook,
  generateTourSummery,
} from '@src/factories';
import { Collection as Data } from '@src/types';

const Factory = (api: API): Data => ({
  id: api.id,
  cover: {
    uri: `${baseURL}/media/v1/image/${api.cover.mediaName}`,
  },
  title: api.title,
  description: api.description,
  journeys: api.journeys.map(({ journey }) => generateJourney(journey)),
  journeysCount: api.journeyCount,
  posts: api.posts.map(({ post }) => generatePost(post)),
  primes: api.primes.map(({ primeDto }) => generatePrimeBook(primeDto)),
  immigrationGuides: api.immigrationGuides.map(({ guideDto }) =>
    generatePrimeBook(guideDto)
  ),
  postsCount: api.postCount,
  toursCount: api.tourCount,
  tours: api.tours.map(({ tour }) => generateTourSummery(tour)),
});

export default Factory;
